export const delay = (timeout = 2000) => new Promise((resolve) => {
    setTimeout(() => resolve(undefined), timeout);
});
